import React from 'react';
import { Error } from 'src/components/page/error/error';

export const ErrorPage: React.FC = () => {
  return <Error />;
};
